import { render, staticRenderFns } from "./SingleFundraiser.vue?vue&type=template&id=160f0adc&scoped=true"
import script from "./SingleFundraiser.vue?vue&type=script&lang=js"
export * from "./SingleFundraiser.vue?vue&type=script&lang=js"
import style0 from "./SingleFundraiser.vue?vue&type=style&index=0&id=160f0adc&prod&lang=scss"
import style1 from "./SingleFundraiser.vue?vue&type=style&index=1&id=160f0adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160f0adc",
  null
  
)

export default component.exports